import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { IUiSchema } from "@rentiohq/shared-frontend/dist/forms/forms.types";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { ERegistrationContractType } from "@rentiohq/shared-frontend/dist/types/registration.types";
import { formatDate } from "@rentiohq/shared-frontend/dist/utils/date.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import utils from "@rentiohq/web-shared/dist/utils";
import { JSONSchema6 } from "json-schema";
import { EField, IExtraData } from "./schema.registrationAddDocument.types";

export const getSchema =
  (
    initialValues: {
      [key: string]: unknown;
    },
    _: IExtraData,
  ) =>
  (defaultValues: { [key: string]: unknown }): JSONSchema6 => {
    const contractTypes = Object.values(ERegistrationContractType).filter(
      contractType => contractType !== ERegistrationContractType.Lease,
    );

    return {
      required: [EField.Type, EField.SignedAtAddendum],
      properties: {
        title1: {
          default: undefined,
        },
        [EField.Type]: {
          default: getValue(EField.Type, initialValues, defaultValues),
          // @ts-ignore
          options: contractTypes.map(id => ({
            id,
            value: getLocalizedText(
              `registration.contract_type.${id}`.toLowerCase(),
            ),
          })),
        },
        [EField.SignedAtAddendum]: {
          default: getValue(
            EField.SignedAtAddendum,
            initialValues,
            defaultValues,
          ),
        },
      },
    };
  };

export const uiSchema = (_: IExtraData): IUiSchema<EField> => {
  return {
    "rentio:title": utils.i18n.t(
      "registration_addendum.create.form.step.addendum_details",
    ),
    title1: {
      "ui:field": ERentioFormField.SectionHeader,
      title: utils.i18n.t("registration.create.form.field.contract_meta_title"),
    },
    [EField.Type]: {
      "ui:field": ERentioFormField.DropdownSelect,
      title: getLocalizedText("registration.create.form.field.contract_type"),
      formatSummary: (formData: ERegistrationContractType) =>
        getLocalizedText(
          `registration.contract_type.${formData}`.toLowerCase(),
        ),
    },
    [EField.SignedAtAddendum]: {
      "ui:field": ERentioFormField.Date,
      title: getLocalizedText(
        "registration.create.form.field.contract_signed_at",
      ),
      maxDate: new Date(),
      formatSummary: formData => (formData ? formatDate(formData) : undefined),
    },
  };
};
